export default "__VITE_ASSET__DEiBRz9K__"